<div class="gp-pull-right pull-right relative-btn">

  <div class="btn-bar-wrapper">
    <div class="btn-bar btn-bar-sm btn-bar-align-end">
      <button type="button" class="btn btn-secondary p-x-md" (click)="cancel()" [disabled]="!isDirty()">
        {{ 'FORMS.cancel' | translate }}
      </button>
      <button type="button"
              class="btn btn-primary p-x-md"
              (click)="save()"
              [disabled]="!isDirty()">
        {{ 'FORMS.submit' | translate }}
      </button>
    </div>
  </div>

</div>

<div class="padding" *ngIf="employee">
  <div class="row">
    <div class="col-xs-12">

      <gp-payroll-prepare-time-and-attendance [contract]="contract"
                                              [employee]="employee"
                                              [cliRegId]="contract?.cliRegID"
                                              [isReadOnly]="contract?.readOnly"
                                              [isEss]="true">
      </gp-payroll-prepare-time-and-attendance>
    </div>
  </div>
</div>
